const updates = [
  {
    date: '2026.07.31',
    tag: '新片上线',
    title: '《时空穿梭者：纪元重启》高清版今日上线',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '2026.07.30',
    tag: '剧集更新',
    title: '《暗夜追踪者》第 12 集已更新，真相浮出水面',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    date: '2026.07.29',
    tag: '系统升级',
    title: '播放器全面升级，新增倍速播放与记忆功能',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '2026.07.28',
    tag: '新片上线',
    title: '暑期档热门综艺合集已上线，一键收藏追更',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '2026.07.27',
    tag: '专题策划',
    title: '「高分经典重映」专题上线，重温影史神作',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    date: '2026.07.26',
    tag: '剧集更新',
    title: '《帝国荣耀：浴火重生》全 50 集更新完毕',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    date: '2026.07.25',
    tag: '功能上线',
    title: '移动端观影体验优化，加载速度提升 40%',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">片源更新、功能升级，一站掌握</p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                {/* Timeline dot */}
                <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-800 font-medium">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}